<template>
  <div>
    <v-container>
      <v-layout wrap>
        <v-flex xs12 sm6>
          <h3 class="headline my-0">GPT</h3>
        </v-flex>
        <v-flex
          xs12
          sm6
          class="form-control text-xs-right"
          style="flex-direction: row; display: flex; gap: 6px"
        >
          <input
            v-model="search"
            name="name"
            class="form-control"
            type="text"
            required
            :placeholder="$t('Search')"
            style="height: 36px"
            @keydown.enter="onSearch()"
            @input="onSearch()"
          />
          <v-btn class="ma-0 mb-1 mr-1" color="primary" @click="isCreateDialog = true">
            <i class="fa fa-plus middle mr-1"></i>
            {{ $t('Add') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout column style="gap: 16px" class="my-4">
        <template v-if="list && list.length > 0">
          <v-flex v-for="(item, index) in list" :key="`document_${index}`" xs12>
            <GptConversationCard
              :data="item"
              @delete="
                handleDelete({
                  index: index,
                  id: item.id,
                  name: item.name
                })
              "
            />
          </v-flex>
        </template>
        <v-card v-else class="text-xs-center" style="margin: 40px 0">
          <h3 class="headline" style="padding: 30px 0">{{ $t('No data') }}</h3>
        </v-card>
        <v-flex xs12 style="display: flex; justify-content: flex-end">
          <v-pagination
            v-model="pageNumber"
            :total-visible="6"
            :length="pageLength"
            @input="handleChangePage"
          ></v-pagination>
        </v-flex>
      </v-layout>
    </v-container>
    <GptConversationCreateDialog
      :show-modal="isCreateDialog"
      @close="isCreateDialog = false"
      @refresh="handleRefreshData"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import GptConversationCreateDialog from './GptConversationCreateDialog.vue'
import GptConversationCard from './GptConversationCard.vue'
import gptApi from '@/api/gpt'
export default {
  components: {
    GptConversationCreateDialog,
    GptConversationCard
  },
  data() {
    return {
      isCreateDialog: false,
      search: '',
      searchTimeout: '',
      total: 0,
      list: [],
      limit: 10,
      offset: 0,
      pageTmp: 1,
      pageNumber: 1
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pageLength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.handleGetDocument()
  },
  methods: {
    onSearch(isImmediate) {
      const search = async () => {
        try {
          this.offset = 0
          this.pageNumber = 1
          await this.handleGetDocument()
        } catch (error) {
          console.error(error)
        }
        this.searchTimeout = null
      }
      if (isImmediate) {
        search()
        return
      }
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }
      this.searchTimeout = setTimeout(search, 1000)
    },
    handleRefreshData() {
      this.offset = 0
      this.pageNumber = 1
      this.handleGetDocument()
    },
    async handleDelete({ index, id, name }) {
      try {
        this.$swal
          .fire({
            title: this.$t('Do you want to delete {name}?', {
              name: name
            }),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: this.$t('Confirm'),
            cancelButtonText: this.$t('cancel'),
            reverseButtons: true
          })
          .then(async (result) => {
            if (result.value) {
              this.handleDeleteByGroupId({ id, index })
            }
          })
      } catch (error) {
        console.error(error)
        this.$swal.fire({
          title: this.$t('Error'),
          type: 'error',
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
      }
    },
    async handleDeleteByGroupId({ id, index }) {
      try {
        this.$store.dispatch('loading')
        const response = await gptApi.deleteDocumentByGroupId({
          pageId: this.selectedBot.pageid,
          data: {
            group_id: id
          }
        })
        const { status } = response
        if ([204].includes(status)) {
          this.$swal
            .fire({
              title: this.$t('Success'),
              type: 'success',
              confirmButtonText: this.$t('Confirm'),
              cancelButtonText: this.$t('cancel'),
              reverseButtons: true
            })
            .then(() => {
              if (index > -1) {
                this.list.splice(index, 1)
              }
            })
        } else {
          this.$swal.fire({
            title: this.$t('Error'),
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            cancelButtonText: this.$t('cancel'),
            reverseButtons: true
          })
        }
      } catch (error) {
        console.error(error)
        this.$swal.fire({
          title: this.$t('Error'),
          type: 'error',
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
      } finally {
        this.$store.dispatch('loading')
      }
    },
    async handleGetDocument() {
      try {
        this.$store.dispatch('loading')
        this.total = 0
        this.list = []
        const response = await gptApi.getDocumentList({
          pageId: this.selectedBot.pageid,
          params: {
            name: this.search.trim(),
            limit: this.limit,
            offset: this.offset
          }
        })
        const { status, data } = response
        if ([200].includes(status)) {
          this.total = data.total || 0
          this.list = data.data || []
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.$store.dispatch('loading')
      }
    },
    handleChangePage(val) {
      if (this.pageTmp !== val) {
        this.pageTmp = val
        this.offset = this.pageNumber * this.limit - this.limit
        if (this.pageNumber != 1) {
          this.offset + 1
        }
        this.handleGetDocument()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/intent/gpt/GptConversation.vue